import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";
import Reveal from "./Reveal";
import { services as S } from "../mock";

const Services = () => {
  const [active, setActive] = useState(0);
  const tab = S.tabs[active];

  return (
    <section id="services" className="bg-[#ececec] py-24 md:py-32 px-5">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3">{S.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl mb-12 text-[#141414]">{S.title}</h2>
        </Reveal>

        <div className="flex flex-wrap gap-3 mb-12">
          {S.tabs.map((t, i) => (
            <button
              key={t.label}
              onClick={() => setActive(i)}
              className={`font-cal text-2xl md:text-4xl px-6 py-2 rounded-full transition-colors ${
                active === i ? "bg-[#1c1c1c] text-white" : "text-[#b0b0b0] hover:text-[#141414]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4 }}
            className="grid md:grid-cols-2 gap-10 items-center bg-white rounded-[32px] p-6 md:p-10"
          >
            <div>
              <h3 className="font-cal text-3xl md:text-4xl leading-snug text-[#141414] mb-8">
                {tab.title}
              </h3>
              <div className="space-y-4">
                {tab.features.map((f) => (
                  <div key={f} className="flex items-center gap-3 text-[#333]">
                    <span className="w-6 h-6 rounded-full bg-[#ff4d17] text-white flex items-center justify-center">
                      <Check size={14} />
                    </span>
                    {f}
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-3xl overflow-hidden bg-[#f0f0f0]">
              <img src={tab.image} alt={tab.label} className="w-full h-[300px] md:h-[380px] object-cover" />
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Services;
